let openCount = 0

export const openSelectDropdown = () => {
  openCount++
}

export const closeSelectDropdown = () => {
  openCount = Math.max(0, openCount - 1)
}

export const hasOpenSelectDropdown = () => openCount > 0
